import { PolygraphyProductFormat } from '../../../../../services/exports/Constants';

export default {
  form: {
    name: {
      label: 'Nome da Tarefa de Impressão',
      placeholder: 'Folheto A5 - promoção especial',
    },
    format: {
      label: 'Tipo de Produto',
      placeholder: 'Selecionar Tipo de Produto',
      options: {
        [PolygraphyProductFormat.FlyerA5]: 'Folheto (A5)',
        [PolygraphyProductFormat.FlyerA6]: 'Folheto (A6)',
        [PolygraphyProductFormat.Sticker60x60]: 'Autocolante (60x60mm)',
        [PolygraphyProductFormat.DoorStickerA5]: 'Autocolante de Porta (30x30cm)',
      },
    },
    file: {
      label: 'Ficheiro',
    },
  },
  buttons: {
    upload: 'Clique ou arraste para carregar o ficheiro',
    save: 'Guardar',
  },
  toasts: {
    changes_got_saved: 'As alterações foram guardadas!',
  },
};
